import { ApiService } from '@DavisDigital/davisdigitalfrontend.module';
import {ChildAccount} from '../interfaces/childAccountResponse';
import { IHttpPromiseCallbackArg } from 'angular';
import {ChildAccountResponse} from '../interfaces/childAccountResponse';

export class AdminAccountService {
	
	constructor(
		private $http,
		private $q: ng.IQService,
		private apiService: ApiService
	){}
	
	public getChildrenAccounts(currentPage = 1, pageRecordShow = 10, countFlag = 0, filters = {}, showAll = false): ng.IPromise<ChildAccountResponse>{
		var deferred = this.$q.defer<ChildAccountResponse>();
		this.apiService
			.request('davisdigital:api.getChildrenAccounts', {currentPage: currentPage, pageRecordShow: pageRecordShow, countFlag: countFlag, filters: filters, showAll: showAll})
			.then((result: IHttpPromiseCallbackArg<ChildAccountResponse>) => {
				let data = {
					recordCount: result.data.recordCount,
					accounts: result.data.accounts
				}
				deferred.resolve(data);
			})
			.catch((result) => {
				deferred.reject(result);
			});
			
		return deferred.promise;
	}
	
	public bulkLockAccounts(accountIDList:string, lockFlag = 0, allAccountsSelected: boolean = false): ng.IPromise<any>{
		var deferred = this.$q.defer();
		this.apiService
			.request('davisdigital:api.updateActiveFlagForChildren', {accountIDList, accountContext:'UpdateActiveFlag', data: { activeFlag: lockFlag}, activeFlag: lockFlag, allAccountsSelected: allAccountsSelected })
			.then((result) => {
				deferred.resolve(result);
			})
			.catch((result) => {
				deferred.reject(result);
			});
			
		return deferred.promise;
	}
	
	public getInitData(): ng.IPromise<any>{
		var deferred = this.$q.defer<any>();
		this.apiService
			.request('davisdigital:api.getDistrictAdminInitData')
			.then((result: IHttpPromiseCallbackArg<any>) => {
				deferred.resolve(result.data.initialDistrictAdminData);
			})
			.catch((result) => {
				deferred.reject(result);
			});
			
		return deferred.promise;
	}
	
	public createAccount(newAccountData): ng.IPromise<any>{
		var deferred = this.$q.defer<any>();
		this.apiService
			.request('davisdigital:api.createAccountAsDistrictAdmin', {newAccountData: newAccountData} )
			.then((result: IHttpPromiseCallbackArg<any>) => {
				deferred.resolve(result.data);
			})
			.catch((result) => {
				deferred.reject(result);
			});
			
		return deferred.promise;
	}
	
	public importAccounts(importFile, dryRun = true): ng.IPromise<any>{
		var deferred = this.$q.defer<any>();
		let formData = new FormData();
		formData.append('importFile', importFile);
		let endpoint = dryRun ? '?slatAction=davisdigital:api.dryRunImportAccountsAsDistrictAdmin' : '?slatAction=davisdigital:api.importAccountsAsDistrictAdmin';
		
		this.$http({
		    url: endpoint,
		    headers: {"Content-Type": undefined },
		    data: formData,
		    method: "PUT"
		})			
		.then((result: IHttpPromiseCallbackArg<any>) => {
			deferred.resolve(result.data);
		})
		.catch((result) => {
			deferred.reject(result);
		});
		
		return deferred.promise;
	}
	
	public getDavisDataImportCount = () =>{
		var deferred = this.$q.defer<any>();
		this.apiService
			.request('davisdigital:api.getDavisDataImportCount', {})
			.then((result: IHttpPromiseCallbackArg<any>) => {
				deferred.resolve(result.data);
			})
			.catch((result) => {
				deferred.reject(result);
			});
			
		return deferred.promise;
	}
	
	public getDavisDataLicenseCount = () =>{
		var deferred = this.$q.defer<any>();
		this.apiService
			.request('davisdigital:api.getDavisDataLicenseCount', {})
			.then((result: IHttpPromiseCallbackArg<any>) => {
				deferred.resolve(result.data);
			})
			.catch((result) => {
				deferred.reject(result);
			});
			
		return deferred.promise;
	}
	
	public getDistrictUsageReport = () =>{
		var deferred = this.$q.defer<any>();
		this.apiService
			.request('davisdigital:api.getDistrictUsageReport', {})
			.then((result: IHttpPromiseCallbackArg<any>) => {
				deferred.resolve(result.data.data);
			})
			.catch((result) => {
				deferred.reject(result);
			});
			
		return deferred.promise;
	}
	
	public getDistrictAccountSettings = () =>{
		var deferred = this.$q.defer<any>();
		this.apiService
			.request('davisdigital:api.getDistrictAccountSettings', {})
			.then((result: IHttpPromiseCallbackArg<any>) => {
				deferred.resolve(result.data.data);
			})
			.catch((result) => {
				deferred.reject(result);
			});
			
		return deferred.promise;
	}
	
		
	public updateDistrictAccountSettings = ( districtAccountSettings:any ) => {
		
		var data = {
			'settings': districtAccountSettings
		}
		
		var deferred = this.$q.defer<any>();
		this.apiService
			.request('davisdigital:api.updateDistrictAccountSettings', data)
			.then((result: IHttpPromiseCallbackArg<any>) => {
				deferred.resolve(result.data.data);
			})
			.catch((result) => {
				deferred.reject(result);
			});
			
		return deferred.promise;
		
	}
	
	/**
	* Method to get data on available / assigned licenses
	**/
	
	public getLicenseData = (accountIDList:string = "", studentEditionOnly:boolean = false, allAccountsSelected: boolean = false, accountFilters: any = {}): ng.IPromise<any> => {
		var deferred = this.$q.defer<any>();
		this.apiService
			.request(
				'davisdigital:api.getAvailableLicensesOnDistrict', 
				{
					accountIDList: accountIDList, 
					studentEditionOnly: studentEditionOnly, 
					allAccountsSelected: allAccountsSelected, 
					accountFilters: accountFilters
				}
			).then((result: IHttpPromiseCallbackArg<any>) => {
				deferred.resolve(result.data);
			})
			.catch((result) => {
				deferred.reject(result);
			});
			
		return deferred.promise;
	}
	
	/**
	* Method to update account permissions for licenses and actions
	**/
	
	public updateLicensePermissions(accountIDList:string, grantLicenses:string, removeLicenses:string, removeAllLicenses:boolean = false, activateAccounts:boolean = false,grantPortfolioAccess:boolean = false,grantImageAccess:boolean = false, allAccountsSelected:boolean = false, accountFilters:any = {}): ng.IPromise<any>{
		var deferred = this.$q.defer<any>();
		this.apiService
			.request('davisdigital:api.updateLicensePermissions', {
				accountIDList: accountIDList,
				grantIDList: grantLicenses,
				removeLicenseIDList: removeLicenses,
				removeAllLicenses: removeAllLicenses,
				activateAccounts: activateAccounts,
				grantPortfolioAccess: grantPortfolioAccess,
				grantImageAccess: grantImageAccess,
				allAccountsSelected: allAccountsSelected,
				accountFilters: accountFilters
			})
			.then((result: IHttpPromiseCallbackArg<any>) => {
				deferred.resolve(result);
			})
			.catch((result) => {
				deferred.reject(result);
			});
			
		return deferred.promise;
	}
	
	/**
	 * Method to get account and licenses information
	 * */
	 public getAccountAndLicenseInfo(accountID:string): ng.IPromise<any>{
	 	return this.apiService
			.request('davisdigital:api.getAccountAndLicenses', {
				districtUserID: accountID,
			});
	 }
	 
	 /**
	* Method to remove account licenses
	**/
	
	public removeLicensesForAccount(removeLicenses:string, accountID:string): ng.IPromise<any>{
		return this.apiService
			.request('davisdigital:api.removeLicensesForAccount', {
				removeLicenseIDList: removeLicenses,
				accountID: accountID
			});
	}
	
	/**
	* Method to re-assign account licenses
	**/
	
	public reassignLicensesForAccount(assignLicenses:string, accountID:string, sourceAccountID: string): ng.IPromise<any>{
		return this.apiService
			.request('davisdigital:api.reassignLicensesForAccount', {
				bookIDList: assignLicenses,
				accountID: accountID,
				sourceAccountID: sourceAccountID
			});
	}

	public deleteAccount(accountID): ng.IPromise<any>{
		return this.apiService.request('davisdigital:api.deleteAccountAsDistrictAdmin', { accountID } );
	}
	
	public updateAccountStatus(accountID, activeFlag): ng.IPromise<any>{
		return this.apiService.request('davisdigital:api.updateAccountStatusAsDistrictAdmin', { accountID, activeFlag} );
	}
	
	public resetAccountPassword(accountID): ng.IPromise<any>{
		return this.apiService.request('davisdigital:api.resetPasswordAsDistrictAdmin', { accountID } );
	}
	
	public updateAccountAsDistrictAdmin(accountID,firstName,lastName,emailAddress,username,role): ng.IPromise<any>{
		return this.apiService.request('davisdigital:api.updateAccountAsDistrictAdmin', { accountID:accountID,firstName:firstName,lastName:lastName,emailAddress:emailAddress,username:username,role:role } );
	}
	
	/**
	* Method to get data on available / assigned licenses
	**/
	
	public getAssignedAccountIDs = (accountIDList:string = "", studentEditionOnly:boolean = false,baseObjectID:string=""): ng.IPromise<any> => {
		var deferred = this.$q.defer<any>();
		this.apiService
			.request(
				'davisdigital:api.getAssignedUsers', 
				{
					accountIDList: accountIDList, 
					studentEditionOnly: studentEditionOnly,
					baseObjectID : baseObjectID
				}
			).then((result: IHttpPromiseCallbackArg<any>) => {
				deferred.resolve(result.data);
			})
			.catch((result) => {
				deferred.reject(result);
			});
			
		return deferred.promise;
	}
	
}